import { GETEMAILLOG_SUCCESS, GETEMAILLOG_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getEmailLogReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETEMAILLOG_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETEMAILLOG_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getEmailLogReducer;



